import { DesigntimeComponent } from './DesigntimeComponent.js'
import * as $ from 'jquery';

class Placeholder extends DesigntimeComponent {
    static staticName = "Placeholder (Dev)";
    static staticId = "placeholder";

    constructor(identifyer) {
        super(identifyer, 1);

        this.values = {
            labelText: { value: "Default text" },
            buttontext: { value: "Next" }
        };
    }

    getRuntimeView(context) {
        var view = $("<div></div>");
        view.append($("<h2>Placeholder</h2>"))
        view.append($("<label>" + this.values.labelText.value + "</label>"))
        return view;
    }
}

export { Placeholder }
